//#region types
import { FormEnums } from "models/enums";
import { FormFieldConstants, IconDefinitionConstants } from "utils/constants";
import { AutoCompleteExtraProps, GenericFormSection } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { ExportedFilesFormTypes } from "models/formTypes";
import { SelectionItem } from "models/utilTypes/selectionTypes";
import { WintSuperkollAPIModelExportItems } from "wint-api-client/dist/types";
import { FilterQueryStateHandler } from "models/propTypes/filterPropTypes";
//#endregion
//#region components
import { useExportItemService } from "serviceHooks";
//#endregion
import { EnumHelper, QueryStateHelper } from "utils/helpers";

function useExportItemsFilterDefinition() {
  const exportItemsService = useExportItemService();
  const getExportedStatesFilterFieldItems = (): SelectionItem[] => {
    return EnumHelper.getNumericItemValues(WintSuperkollAPIModelExportItems.ExportItemState).map((keyValue) => ({
      id: keyValue as number,
      value: exportItemsService.getStateText(keyValue),
    }));
  };

  const filterFormFields: GenericFormSection<ExportedFilesFormTypes.ExportItemsFilter>[] = [
    {
      label: TranslationKeys.Common.Date,
      type: FormEnums.FormSectionType.EXPANDABLESECTION,
      icon: IconDefinitionConstants.WSliders,
      innerFields: {
        dateRange: {
          label: TranslationKeys.Common.DateRange,
          type: FormEnums.FormFieldType.DATERANGE,
        },
      },
    },
    {
      label: TranslationKeys.Common.General,
      type: FormEnums.FormSectionType.EXPANDABLESECTION,
      icon: IconDefinitionConstants.WSliders,
      innerFields: {
        onlyMine: {
          label: TranslationKeys.Common.OnlyMine,
          type: FormEnums.FormFieldType.TOGGLE,
        },
        state: {
          label: TranslationKeys.Common.Status,
          type: FormEnums.FormFieldType.SELECTION,
          extraProps: {
            items: getExportedStatesFilterFieldItems(),
          } as AutoCompleteExtraProps<ExportedFilesFormTypes.ExportItemsFilter>,
        },
      },
    },
  ];

  const filterQueryStateHandler: FilterQueryStateHandler<ExportedFilesFormTypes.ExportItemsFilter> = {
    onlyMine: QueryStateHelper.booleanQueryEncoder(FormFieldConstants.ExportedFiles.ExportItemsFilter.OnlyMine),
    dateRange: QueryStateHelper.dateRangeQueryEncoder(FormFieldConstants.ExportedFiles.ExportItemsFilter.DateRange),
    state: QueryStateHelper.numberQueryEncoder(FormFieldConstants.ExportedFiles.ExportItemsFilter.State),
  };

  return { filterFormFields, filterQueryStateHandler };
}

export default useExportItemsFilterDefinition;
